import React from "react";

// Todos los modulos usan el mismo color cuando estan activos.
const estiloBoton = (activo) => ({
  padding: '10px 20px',
  borderRadius: '5px',
  fontWeight: 'bold',
  cursor: 'pointer',
  border: 'none',
  transition: 'all 0.3s',
  backgroundColor: activo ? '#003b5c' : '#f0f0f0',
  color: activo ? 'white' : '#333'
});

const MenuModulos = ({ vistaActiva, setVistaActiva, setAlumnoSeleccionado, cajeroRol }) => {
  return (
    <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap', backgroundColor: '#fff', padding: '10px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
      <button
        onClick={() => setVistaActiva('busqueda')}
        style={estiloBoton(vistaActiva === 'busqueda')}
      >
        👨‍🎓 Módulo Alumnos
      </button>

      <button
        onClick={() => {
          setVistaActiva('externos');
          setAlumnoSeleccionado(null);
        }}
        style={estiloBoton(vistaActiva === 'externos')}
      >
        ☕ Módulo Externos
      </button>

      <button
        className={`btn-modulo ${vistaActiva === 'aspirantes' ? 'activo' : ''}`}
        onClick={() => {
          setVistaActiva('aspirantes');
          setAlumnoSeleccionado(null);
        }}
        style={estiloBoton(vistaActiva === 'aspirantes')}
      >
        📝 Módulo Aspirantes
      </button>

      <button
        onClick={() => {
          setVistaActiva('exalumnos');
          setAlumnoSeleccionado(null);
        }}
        style={estiloBoton(vistaActiva === 'exalumnos')}
      >
        🎓 Ex-alumnos
      </button>

      <button
        onClick={() => {
          setVistaActiva('reportes');
          setAlumnoSeleccionado(null);
        }}
        style={estiloBoton(vistaActiva === 'reportes')}
      >
        📊 Reportes
      </button>

      {String(cajeroRol) === "1" && (
        <button
          onClick={() => {
            setVistaActiva('usuarios');
            setAlumnoSeleccionado(null);
          }}
          style={estiloBoton(vistaActiva === 'usuarios')}
        >
          👥 Usuarios
        </button>
      )}
    </div>
  );
};

export default MenuModulos;
